export const envOptions = {
  local: 'http://app.branchup.com:8000/',
  qa: 'https://app.qa.branchup.travel/',
  prod: 'https://app.branchup.travel/'
};
